import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  ConfirmsDeleteAction,
  DefaultEditorValue,
  GetCreateTable,
  ShowsEditor,
} from "../../core/Helper2";

import { BuildsColumnsWithEdit } from "../../core/TableHelper";
import {
  AppointmentService,
  AppointObj,
} from "../../model/backoffice/appointment";
import ConfirmDialogB, { ConfirmDefault } from "../components/ConfirmDialogB";
import { IsCanDelete } from "../../core/Helper3";

import TechAppointmentEditor from "./TechAppointmentEditor";
import { TopToolBar } from "../../core/TopToolbar";

export default function TechAppointment() {
  const userInfo = useSelector((state) => state.user);
  const [table, setTable] = useState();
  const [confirm, setConfirm] = useState(ConfirmDefault);
  const [editor, setEditor] = useState(DefaultEditorValue);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [text, setText] = useState("");
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const _idFiledsName = "AppointId";

  // useEffect(() => {
  //   // console.log(data);
  // }, [data]);

  useEffect(() => {
    getData("", [new Date(), new Date()]);

    return () => {
      setData([]);
      setEditData([]);
      setTable(null);
      setEditor(null);
    };
  }, []);

  //** Get data list */
  const getData = async (text, dateRangeValue) => {
    let ret = await AppointmentService.GetList(
      { text: text, dateRange: dateRangeValue },
      userInfo.detail
    );
    if (ret) {
      setData(ret);
    }
    setEditor(DefaultEditorValue);
  };

  const actionAddNew = async () => {
    ShowsEditor(setEditor, _idFiledsName, 0, () => getData(text, dateRange));
  };

  const dispatch = useDispatch();

  const actionEdit = (x, row) => {
    ShowsEditor(setEditor, _idFiledsName, row[_idFiledsName], () =>
      getData(text, dateRange)
    );
  };

  /** DELETE */
  const actionDelete = async (x, row) => {
    if (!IsCanDelete(userInfo.userRule, dispatch)) return;
    ConfirmsDeleteAction(setConfirm, async () => {
      let res = await AppointmentService.DeleteItem(
        { [_idFiledsName]: row[_idFiledsName] },
        userInfo.detail
      );
      if (res) {
        getData();
      }
    });
  };

  /** Effect DATA */
  useEffect(() => {
    let columns = BuildsColumnsWithEdit(
      AppointObj({}),
      actionEdit,
      actionDelete
    );

    setTable(
      GetCreateTable({
        idFieldName: _idFiledsName,
        columns: columns,
        data: data,
      })
    );
  }, [data]);
  return (
    <>
      <TopToolBar
        onAddNew={actionAddNew}
        addNewTitle={"เพิ่มใหม่"}
        title={"ตารางนัดคนไข้"}
        searchHandler={(text, dateRangeValue) => {
          setText(text);
          setDateRange(dateRangeValue);
          getData(text, dateRangeValue);
        }}
        dateFilter={true}
      ></TopToolBar>
      {table}
      <TechAppointmentEditor
        {...{ editor: [editor, setEditor], data: [editData, setEditData] }}
      />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </>
  );
}
